var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isEmpty(_vm.company))?_c('div',{staticClass:"d-flex"},[_c('span',{staticClass:"navbar-text d-none d-sm-block"},[_c('strong',[_vm._v(_vm._s(_vm.company.name))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }